<template>
  <div class="py-4 container-fluid">
        <div class="card mb-5" ref="pdfContent">
            <div class="row mb-5">
                <div class="col-lg-12">
                    <div class="card-header p-3 pt-2">
                        <img
                            :src="isLoading ? loadingImageUrl : associationLogoImageSrc"
                            :alt="$t('association.Logo_image')"
                            style="width: 200px;"
                            />  
                        <h6 class="mb-2">{{ animal.associationName }}</h6>
                    </div>
                </div>
                <!-- LEFT: animal overview -->
                <div class="col-lg-4">
                    <div class="card-header p-3 pt-2">
                        <h4>Overzicht afstamming van</h4>
                        <div>
                            <dl class="row mb-0 small">
                                <dt class="col-6 text-muted">Stamboeknummer: </dt><dd class="col-6 line-height-20">{{ animal.studbookNumber }}&nbsp;</dd> 
                                <dt class="col-6 text-muted">Levensnummer: </dt><dd class="col-6 line-height-20">{{ animal.tagNumber }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Landcode: </dt><dd class="col-6 line-height-20">{{ animal.countryCode }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Ras:  </dt><dd class="col-6 line-height-20">{{ animal.breedName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Kleur: </dt><dd class="col-6 line-height-20">{{ animal.colorName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Naam: </dt><dd class="col-6 line-height-20">{{ animal.animalName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geslacht: </dt><dd class="col-6 line-height-20">{{ animal.gender }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geboortedatum: </dt><dd class="col-6 line-height-20">{{ animal.birthDate }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Worpgrootte: </dt><dd class="col-6 line-height-20">{{ animal.litterSize }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal worpen: </dt><dd class="col-6 line-height-20">{{ animal.noParities }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal lammeren: </dt><dd class="col-6 line-height-20">{{ animal.noLambs }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Scrapie: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Zwoeger: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName2 }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Stamboeksectie: </dt><dd class="col-6 line-height-20">{{ animal.studebookSectionDescription }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Status: </dt><dd class="col-6 line-height-20">{{ animal.studebookStatus }}&nbsp;</dd>
                                                                
                                <!-- KEURSTW -->
                                <template v-for="attr in keurstwItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <!-- KEURPNT -->
                                <template v-for="attr in keurpntItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <dt class="col-6 text-muted">Fokker: </dt><dd class="col-6 line-height-20">{{ animal.breederName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Houder: </dt><dd class="col-6 line-height-20">{{ animal.keeperName }}&nbsp;</dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <!-- RIGHT: pedigree L→R rows with brackets -->
                <div class="col-lg-8">
                    <!-- Row 1: FATHER side -->
                    <div class="ped-row mb-5">
                        <!-- left: father card -->
                        <div class="ped-left">                            
                            <PedigreeCard
                                v-if="pedigree1?.selectedanimal?.father"
                                :node="pedigree1.selectedanimal.father"
                                label="Vader"
                                :id="pedigree1.selectedanimal.father.id"
                            />                            
                        </div>

                        <!-- right: father’s parents + their parents -->
                        <div class="ped-right">
                            <!-- father’s father branch -->
                            <div v-if="pedigree1.selectedanimal.father?.father" class="branch">
                                <div class="parent">
                                    <PedigreeCard                                    
                                        :node="pedigree1.selectedanimal.father.father"
                                        label="Vader"
                                        :id="pedigree1.selectedanimal.father.father.id"
                                    />                                    
                                </div>                                
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.father"
                                            :node="pedigree1.selectedanimal.father.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.father.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.mother"
                                            :node="pedigree1.selectedanimal.father.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.father.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- father’s mother branch -->
                            <div v-if="pedigree1.selectedanimal.father?.mother" class="branch mt-4">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.father.mother"
                                    label="Moeder"
                                    :id="pedigree1.selectedanimal.father.mother.id"
                                    />                            
                                </div>                                
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.father"
                                            :node="pedigree1.selectedanimal.father.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.mother.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.mother"
                                            :node="pedigree1.selectedanimal.father.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.mother.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>

                    <!-- Row 2: MOTHER side -->
                    <div class="ped-row">
                        <!-- left: mother card -->
                        <div class="ped-left">
                            <PedigreeCard
                            v-if="pedigree1?.selectedanimal?.mother"
                            :node="pedigree1.selectedanimal.mother"
                            label="Moeder"                            
                            :id="pedigree1.selectedanimal.mother.id"
                            />
                            
                        </div>
                        
                        <!-- right: mother’s parents + their parents -->
                        <div class="ped-right">
                            <!-- mother’s father branch -->
                            <div v-if="pedigree1.selectedanimal.mother?.father" class="branch">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.mother.father"
                                    label="Vader"
                                    :id="pedigree1.selectedanimal.mother.father.id"
                                    />
                                </div>                                
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.father"
                                            :node="pedigree1.selectedanimal.mother.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother?.father?.father?.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vader"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.mother"
                                            :node="pedigree1.selectedanimal.mother.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother?.father?.mother?.id"
                                        />                                        
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- mother’s mother branch -->
                            <div v-if="pedigree1.selectedanimal.mother?.mother" class="branch mt-4">
                                <div class="parent">
                                    <PedigreeCard
                                    :node="pedigree1.selectedanimal.mother.mother"
                                    label="Moeder"
                                    :id="pedigree1.selectedanimal.mother.mother.id"
                                    />                            
                                </div>                                
                                <div class="children">
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.father"
                                            :node="pedigree1.selectedanimal.mother.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother.mother.father.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData 
                                                label="Vander"
                                            />
                                        </div>
                                    </div>
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.mother"
                                            :node="pedigree1.selectedanimal.mother.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother.mother.mother.id"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData
                                                label="Moeder"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
            </div>
        </div>        
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link v-if="!isEmbedded" to="/animal" class="btn btn-sm bg-gradient-danger float-start  ms-2">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 me-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>
        </div>
    </div>
    
  <div class="container-fluid py-4">
    <div class="pedigree-wrapper">
      <div class="animal-section">
        <PedigreeNode :node="pedigree1?.selectedanimal" label="Animal" />
      </div>
      <div class="parents-row">
        <div class="parent-side">
          <!-- Father -->
          <PedigreeNode :node="pedigree1?.selectedanimal?.father" label="Father" />
          <!-- Grand Parents -->
          <div class="grandparents-row">
            <!-- FF -->
            <PedigreeNode :node="pedigree1?.selectedanimal?.father?.father" label="FF" />
            <!-- FM -->
            <PedigreeNode :node="pedigree1?.selectedanimal?.father?.mother" label="FM" />
          </div>
        </div>
        <div class="parent-side">
          <!-- Mother -->
          <PedigreeNode :node="pedigree1?.selectedanimal?.mother" label="Mother" />
          <!-- Grand Parents -->
          <div class="grandparents-row">
            <!-- MF -->
            <PedigreeNode :node="pedigree1?.selectedanimal?.mother?.father" label="MF" />
            <!-- MM -->
            <PedigreeNode :node="pedigree1?.selectedanimal?.mother?.mother" label="MM"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PedigreeNode from './components/PedigreeNode.vue'

export default {
  name: 'PedigreeNew',
  components: {
    PedigreeNode
  },

  data() {
    return {
      pedigree1: {
        selectedanimal: {
          name: 'Animal A',
          studbooknumber: 'SB-1001',
          birthdate: '01-01-2020',
          gender: 'M',
          father: {
            name: 'Father A',
            studbooknumber: 'SB-2001',
            birthdate: '01-01-2018',
            gender: 'M',
            father: {
              name: 'FF Animal',
              studbooknumber: 'SB-3001',
              birthdate: '01-01-2016',
              gender: 'M'
            },
            mother: {
              name: 'FM Animal',
              studbooknumber: 'SB-3002',
              birthdate: '01-01-2016',
              gender: 'F'
            }
          },
          mother: {
            name: 'Mother A',
            studbooknumber: 'SB-2002',
            birthdate: '01-01-2018',
            gender: 'F',
            father: {
              name: 'MF Animal',
              studbooknumber: 'SB-3003',
              birthdate: '01-01-2016',
              gender: 'M'
            },
            mother: {
              name: 'MM Animal',
              studbooknumber: 'SB-3004',
              birthdate: '01-01-2016',
              gender: 'F'
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

.pedigree-wrapper{
    display:flex;
    flex-direction:column;
    align-items:center;
    padding:10px;
    gap:35px;
}

.animal-section{
    position:relative;
}

/* vertical line */
.animal-section::after{
    content:"";
    position:absolute;
    left:50%;
    top:100%;
    width:2px;
    height:18px;
    background:#d6d6d6;
    transform:translateX(-50%);
}

.parents-row{
    display:flex;
    gap:45px;
    position:relative;
}

/* top connector */
.parents-row::before{
    content:"";
    position:absolute;
    top:-10px;
    left:25%;
    right:25%;
    height:2px;
    background:#d6d6d6;
}

.parent-side{
    display:flex;
    flex-direction:column;
    align-items:center;
    gap:20px;
    position:relative;
}

/* vertical connector */
.parent-side::before{
    content:"";
    position:absolute;
    top:-10px;
    width:2px;
    height:10px;
    background:#d6d6d6;
}

.grandparents-row{
    display:flex;
    gap:14px;
    position:relative;
}

/* horizontal connector */
.grandparents-row::before{
    content:"";
    position:absolute;
    top:-10px;
    left:25%;
    right:25%;
    height:2px;
    background:#d6d6d6;
}

/* vertical connector */
.grandparents-row > *{
    position:relative;
}

.grandparents-row > *::before{
    content:"";
    position:absolute;
    top:-10px;
    left:50%;
    width:2px;
    height:10px;
    background:#d6d6d6;
    transform:translateX(-50%);
}

.ped-card{
    width:250px;
    border-radius:10px;
    overflow:hidden;
    background:#ffffff;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
    transition:all .2s ease;
}

.ped-card:hover{
    transform:translateY(-1px);
}

.ped-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:8px 12px;
    color:#ffffff;
    font-size:14px;
    font-weight:600;
}

.bg-male{
    background:#4e61d3;
}

.bg-female{
    background:#d63384;
}

.ped-body{
    padding:10px;
}

.ped-row{
    margin-bottom:5px;
    line-height:1.2;
}

.ped-label{
    font-weight:700;
    color:#667085;
    font-size:12px;
}

.ped-value{
    color:#667085;
    font-size:12px;
}

.ped-green{
    color:#0f8d09;
    font-weight:600;
}

.ped-table{
    width:100%;
    border-collapse:collapse;
    margin-top:8px;
    text-align:center;
}

.ped-table th{
    background:#f3f4f6;
    padding:3px;
    border:1px solid #e5e7eb;
    font-size:10px;
    font-weight:700;
}

.ped-table td{
    padding:4px;
    border:1px solid #e5e7eb;
    font-size:10px;
    color:#6b7280;
}

@media (max-width:1200px){
    .parents-row{
        flex-direction:column;
        gap:35px;
    }

    .parents-row::before{
        display:none;
    }
}

@media (max-width:768px){
    .grandparents-row{
        flex-direction:column;
    }

    .grandparents-row::before{
        display:none;
    }

    .grandparents-row > *::before{
        display:none;
    }

    .ped-card{
        width:100%;
    }
}
</style>